export enum IconType {
  materialIcon = 'material-icon',
  materialSymbol = 'material-symbol',
}

export type NavItemChild = {
  name: string;
  route?: string;
  onClick?: Function;
  queryParams?: { [x: string]: any };
};

export type NavItem = {
  name: string;
  route?: string;
  icon?: string;
  iconType?: IconType;
  onClick?: Function;
  badge?: string;
  queryParams?: { [x: string]: any };
  children?: NavItemChild[];
  expand?: boolean;
  parentRoute?: string;
};
